module.exports = __webpack_public_path__ + "img/novelty-frame.b7d60baa.png";